export const ACCIDENT_FORM_MODAL_STYLES = {
  width: '770px',
  height: '924px',
};
